export enum BitLockerCompliance {
  UNKNOWN = 1,
  COMPLIANT = 2,
  NON_COMPLIANT = 3,
  INAPPLICABLE = 4,
}